<div class="spinner loading-overlay" [ngClass]="{hide: !show, show: show}">
</div>
<div [ngClass]="{hide: !show, show: show}" class="spinner-container text-center">
    <div class="spinner-container-inner">
        <i class="fas fa-spinner fa-pulse fa-3x fa-fw"></i>
        <div class="m-t-1" [innerHTML]="message || 'Loading...'"></div>
    </div>
</div>
